import API from "@/API";

const SET_LIST = "SET_LIST";
const SET_PRELOADER = "SET_PRELOADER";
const SET_TOTALS_PAGINATION = "SET_TOTALS_PAGINATION";
const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
const SET_SORT = "SET_SORT";
const SET_TEXT_SEARCH = "SET_TEXT_SEARCH";

export default {
  namespaced: true,

  state: {
    list: [],
    pagination: {
      current: 1,
      totalPages: 1,
      totalResults: 1
    },
    sort: "",
    text_search: "",
    preloader: false
  },

  actions: {
    async index({ state, commit }) {
      commit("SET_PRELOADER", true);

      try {
        let results = await API.Physicals.index(
          state.text_search,
          state.pagination.current
        );

        commit("SET_TOTALS_PAGINATION", results.meta);
        commit("SET_LIST", results.data);
      } catch (e) {
        throw e;
      }

      commit("SET_PRELOADER", false);
    },

    setCurrentPage({ commit, dispatch }, page) {
      commit("SET_CURRENT_PAGE", page);
      dispatch("index");
    },

    setSort({ commit, dispatch }, payload) {
      commit("SET_SORT", payload);
      dispatch("index");
    },

    setTextSearch({ commit, dispatch }, payload) {
      commit("SET_TEXT_SEARCH", payload);
      commit("SET_CURRENT_PAGE", 1);
      dispatch("index");
    },

    async searchByName({ commit }, text) {
      try {
        return await API.Physicals.searchByName(text);
      } catch (e) {
        throw e;
      }
    },

    async show({ commit }, id) {
      try {
        return await API.Physicals.show(id);
      } catch (e) {
        throw e;
      }
    },

    async update({ commit }, payload) {
      try {
        return await API.Physicals.update(payload);
      } catch (e) {
        throw e;
      }
    },

    async create({ commit }, payload) {
      try {
        let customer = await API.Physicals.create(payload);
        customer.phone = payload.phones[0];
        customer.address = payload.address;
        customer.document = {
          document_type: "CPF",
          document_number: customer.cpf
        };

        await API.Account.sendEmailVerification(customer.account.id);
        await API.Account.verifyEmail(customer.account.id);
        await API.PaymentGatewayAccount.create(customer);
        await API.PaymentGatewayCustomer.create(customer);
        await API.PaymentGatewayAccount.createOnGateway(customer.account.id);
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {
    [SET_LIST](state, payload) {
      state.list = payload;
    },
    [SET_PRELOADER](state, payload) {
      state.preloader = payload;
    },
    [SET_TOTALS_PAGINATION](state, payload) {
      state.pagination.totalPages = payload.page_count;
      state.pagination.totalResults = payload.record_count;
    },
    [SET_CURRENT_PAGE](state, payload) {
      state.pagination.current = payload;
    },
    [SET_SORT](state, payload) {
      state.sort = payload;
    },
    [SET_TEXT_SEARCH](state, payload) {
      state.text_search = payload;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/physicals.js